import styles from './Staff.module.css';

import IconAndName from '../../components/IconAndName/IconAndName';

import { FaUserPlus, FaUpload } from 'react-icons/fa';

import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';
import CopyRight from '../../components/CopyRight/CopyRight';

import StaffListTable from '../../sections/StaffListTable/StaffListTable';

const Staff = () => {
  // default or make it dynamic later

  const handleAddStaff = () => {
    dispatch(openModal('addStaff'));
  };

  const handleBulkUpload = () => {
    dispatch(openModal('bulkUploadStaff'));
  };

  const dispatch = useDispatch();

  return (
    <>
      <div className={styles.StaffSection}>
        <div className={styles.maincontainer}>
          <div className={styles.buttonRow}>
            <IconAndName
              icon={<FaUserPlus />}
              title="Add Staff"
              bgColor="Primary_Color"
              onClick={handleAddStaff}
            />
            <IconAndName
              icon={<FaUpload />}
              title="Bulk Upload"
              bgColor="Primary_Color"
              onClick={handleBulkUpload}
            />
          </div>
        </div>

        <div className={styles.contentSpacing}>
          <StaffListTable />
        </div>
      </div>

      <CopyRight />
    </>
  );
};

export default Staff;
